(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  document.documentElement.classList.add('gp-motion-enabled');

  const selectors = [
    '.gp-section-head',
    '.gp-trust__item',
    '.gp-collection-tile',
    '.gp-split-card',
    '.gp-care__item',
    '.gp-help__inner',
    '.featured-collection .grid__item',
    '.collection .product-grid .grid__item',
    '.related-products .grid__item',
    '.collection-hero__text-wrapper',
    '.collection-hero__image-container',
    '.product__media-wrapper',
    '.product__info-wrapper',
    '.gp-detail-card',
    '.main-page-title',
    '.newsletter__wrapper > *',
    '.footer-block'
  ];

  const selector = selectors.join(',');
  let observer;

  const revealImmediately = (element) => element.classList.add('is-gp-visible');

  const prepare = (root = document) => {
    const elements = [];
    if (root.matches?.(selector)) elements.push(root);
    root.querySelectorAll?.(selector).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (element.dataset.gpRevealReady === 'true') return;
      element.dataset.gpRevealReady = 'true';
      element.setAttribute('data-gp-reveal', '');

      const siblings = element.parentElement
        ? Array.from(element.parentElement.children).filter((child) => child.matches?.(selector))
        : [];
      const order = Math.max(0, siblings.indexOf(element));
      element.style.setProperty('--gp-reveal-delay', `${Math.min(order, 5) * 65}ms`);

      if (!observer) {
        revealImmediately(element);
        return;
      }

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) revealImmediately(element);
      else observer.observe(element);
    });
  };

  const initialize = () => {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealImmediately(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    }

    prepare(document);

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) prepare(node);
      }));
    });
    mutationObserver.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  }
})();
